@if (useHorizontalNav) {
<div class="admin-layout admin-layout--horizontal">
  <header class="admin-topbar" role="banner">
    <div class="admin-topbar__primary">
      <div class="admin-topbar__brand">
        <h1>ISSUE TRACKER</h1>
        <p>Gestión de contenidos</p>
      </div>
      @if (menuItems.length > 1) {
      <nav class="admin-topbar__nav" aria-label="Navegación principal">
        @for (item of menuItems; track item.route) {
        <a
          [routerLink]="[item.route]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
          class="nav-link nav-link--horizontal">
          <i [class]="item.iconClass + ' menu-icon'" aria-hidden="true"></i>
          <span class="menu-label">{{ item.label }}</span>
        </a>
        }
      </nav>
      }
      <div class="admin-topbar__actions">
        @if (userInfo()) {
        <span class="user-info">{{ userInfo().User }}{{ userInfo().Name ? ' - ' + userInfo().Name : '' }}</span>
        }
        <button class="icon-btn" type="button" title="Cerrar sesion" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i>
        </button>
      </div>
    </div>
  </header>

  <div class="admin-main">
    <div class="admin-toolbar">
      <h2>{{ pageTitle }}</h2>
    </div>
    <div class="content-wrapper">
      <div class="content">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
} @else {
<div class="admin-layout admin-layout--sidebar">
  <div class="sidebar" [class.collapsed]="isSidebarCollapsed">
    <div class="sidebar-header">
      <div class="sidebar-header-top">
        <h1>ISSUE TRACKER</h1>
        <button class="toggle-btn" type="button" aria-label="Alternar menu" (click)="toggleSidebar()">
          <i class="bi bi-list"></i>
        </button>
      </div>
      <p>Gestión de contenidos</p>
    </div>

    <nav class="sidebar-nav" aria-label="Navegación principal">
      @for (item of menuItems; track item.route) {
      <div class="nav-item" animate.enter="loaded-height-enter">
        <a
          [routerLink]="[item.route]"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
          class="nav-link">
          <i [class]="item.iconClass + ' menu-icon'" aria-hidden="true"></i>
          <span class="menu-label">{{ item.label }}</span>
        </a>
      </div>
      }

      @if (userFilters().length > 0) {
      <hr>

      <div class="nav-item" animate.enter="loaded-height-enter">
        <button
          class="nav-link"
          type="button"
          (click)="toggleMenu('filtros')"
          [class.collapsed]="!isMenuOpen('filtros')"
          [attr.aria-expanded]="isMenuOpen('filtros')">
          <i class="bi bi-filter menu-icon"></i>
          <span>Mis Filtros</span>
          <i class="bi bi-chevron-down chevron"></i>
        </button>
        <div class="nav-submenu" [class.show]="isMenuOpen('filtros')" data-ap-parent="filtros">
          @for (filter of userFilters(); track filter.IdFilter) {
          <div class="nav-item nav-item-filter">
            <a role="button" (click)="applyFilter(filter)" class="nav-link nav-link-filter">
              <i class="bi bi-filter menu-icon"></i>
              <span>{{ filter.FilterName }}</span>
            </a>
            <button
              type="button"
              class="btn btn-link"
              (click)="deleteFilter(filter, $event)"
              title="Eliminar filtro"
              [attr.aria-label]="'Eliminar filtro ' + filter.FilterName">
              <i class="bi bi-x-lg"></i>
              <span class="visually-hidden">Eliminar filtro</span>
            </button>
          </div>
          }
        </div>
      </div>
      }

      <hr>

      <div class="nav-item">
        <a role="button" class="nav-link" (click)="previewWidget()">
          <i class="bi bi-pip"></i>
          <span class="menu-label">Previsualizar widget</span>
        </a>
      </div>
    </nav>
  </div>

  <div class="main-wrapper" [class.sidebar-collapsed]="isSidebarCollapsed">
    <div class="header">
      <div class="header-left">
        <button class="toggle-btn" type="button" aria-label="Alternar menu" (click)="toggleSidebar()">
          <i class="bi bi-list"></i>
        </button>
        <h2>{{ pageTitle }}</h2>
      </div>
      <div class="header-actions">
        @if (userInfo()) {
        <span class="user-info">{{ userInfo().User }}{{ userInfo().Name ? ' - ' + userInfo().Name : '' }}</span>
        }
        <button class="icon-btn" type="button" title="Cerrar sesion" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="content">
        <router-outlet />
      </div>
    </div>
  </div>
</div>
}
